module.exports = __webpack_public_path__ + "img/7_134.ea6fa73a.png";